import axios from "axios";

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      axios
        .get("/notifications/")
        .then((response) => {
          context.commit("setNotifications", response.data.results);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
